<template>
    <div class="form">
        <Form ref="info" :model="info" :label-width="100" viewonly>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="物品清单" prop="fList">
                        <room-config :value="info.fList" />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="remark">
                        <Input
                            v-model="info.remark"
                            type="textarea"
                            :rows="3"
                            placeholder
                            readonly
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import RoomConfig from '_vc/fields/room-config'

import { assetsRentalFacility } from '@/api/assets'

export default {
    name: 'FListFrom',

    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },

    components: { RoomConfig },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                fList: [], // 物品清单
                remark: '', // 备注
            },
        }
    },

    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        var btns = [{ type: 'default', text: '关闭', name: 'cancel' }]

        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([assetsRentalFacility(this.id)])
                .then((args) => {
                    var [view] = args
                    const list = view.data.list
                    if (list?.length) {
                        list.forEach((v) => {
                            v.parentId = v.pid
                            v.parentTitle = v.pTitle
                        })
                        this.info.fList = list
                        this.info.remark = list[0].remark
                    }
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
